module.exports = __webpack_public_path__ + "static/web-design-header-34bf608f32fcf492e5fd880d4efd5df4.jpg";